module.exports = __webpack_public_path__ + "img/SKMJ_che2.5c6cae87.jpg";